export default "__VITE_ASSET__889dcae4__"